import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import SearchForm from "./Pages/SearchForm/SearchForm";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<SearchForm />} />
          <Route exact path="/case_result" element={""} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
